import React from 'react';
import { img } from '../lib/content';

// A media picked in the CMS is tagged with a "#video" fragment when it's a video.
const isVideoSrc = (s) =>
  typeof s === 'string' && (s.includes('#video') || /\.(mp4|webm|mov|m4v|ogg)(\?|#|$)/i.test(s));

// Renders a looping muted <video> when the source is a video, otherwise an <img>.
// Drop-in replacement for `<img src={img(x)} .../>` — pass the RAW cms value as `src`.
const SmartMedia = ({ src, alt = '', className = '', controls = false, ...rest }) => {
  const raw = typeof src === 'string' ? src : '';
  const resolved = img(raw.replace('#video', ''));

  if (isVideoSrc(raw)) {
    return (
      <video
        src={resolved}
        className={className}
        autoPlay
        loop
        muted
        playsInline
        controls={controls}
        {...rest}
      />
    );
  }
  return <img src={resolved} alt={alt} className={className} draggable={false} {...rest} />;
};

export default SmartMedia;
